import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from "../constants/authConstants";

// Get the user from localStorage if already logged in
const userInfoFromStorage = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;

const initialState = {
    loading: false,
    userInfo: userInfoFromStorage,
    error: null,
};

export const authReducer = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {
                ...state,
                loading: true,
            };
        
        case LOGIN_SUCCESS:
            return {
                loading: false,
                userInfo: action.payload,
                error: null
            };
            
        case LOGIN_FAIL:
            return {
                loading: false,
                userInfo: null,
                error: action.payload,
            };
            
        case LOGOUT:
            return {
                loading: false,
                userInfo: null,
                error: null,
            }
        
        default:
            return state;    
    }
}